import privateAxios from "../utils/axiosPrivate";
import { getOnboarStatusCheckTokenUrl } from "../utils/constants/apiEndPoints";
import {
  createSlice,
  createAsyncThunk,
  isRejectedWithValue
} from "@reduxjs/toolkit";

// Initial state
const initialState = {
  applyIdDataToken: []
};

// Slice
const agreementPagesSlice = createSlice({
  name: "agreementPages",
  initialState,
  reducers: {
    setApplyIdDataToken(state, action) {
      state.applyIdDataToken = action.payload;
    }
  }
});

// Thunk: get customer list
export const fetchApplyIdStatusThunk = createAsyncThunk(
  "agreementPages/fetchApplyIdStatusThunk",
  async (payload, { dispatch }) => {
    try {
      const response = await privateAxios.get(getOnboarStatusCheckTokenUrl, {
        params: payload
      });

      dispatch(setApplyIdDataToken(response.data.data));
      return response;
    } catch (error) {
      return isRejectedWithValue(error.response);
    }
  }
);

// Actions & Reducer
export const { setApplyIdDataToken } = agreementPagesSlice.actions;

export default agreementPagesSlice.reducer;
